import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import * as React from 'react';
import withStyles from '../../core/withStyles';
import styles from './Row.styles';
export const Row = ({ className, inline, halfMargin, doubleMargin, center, classes, children, onClick, }, ref) => {
    return (_jsx("div", Object.assign({ ref: ref, className: cn(classes.root, inline && classes.inline, center && classes.center, halfMargin && classes.halfMargin, doubleMargin && classes.doubleMargin, onClick && classes.clickable, className), onClick: onClick }, { children: children })));
};
// @ts-ignore
export default withStyles(styles)(React.forwardRef(Row));
//# sourceMappingURL=Row.js.map